function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPartnerComBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.5 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1 copy 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.14,11a.13.13,0,0,1,.07,0A2.74,2.74,0,0,0,7.77,9.59a.32.32,0,0,0-.3.22L6.41,13,6,11.08h.07a.24.24,0,0,0,.24-.24V10.2A.24.24,0,0,0,6.11,10H5.27A.24.24,0,0,0,5,10.2v.64a.24.24,0,0,0,.24.24h.06L5,13,3.91,9.81a.3.3,0,0,0-.3-.22A2.85,2.85,0,0,0,.76,12L0,15a1.08,1.08,0,0,0,1.05,1.33h7v0l.71-3.06A4.31,4.31,0,0,1,10.14,11Z",
    style: {
      fill: "#1c6f97"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.68,
    cy: 5.97,
    r: 3.36,
    style: {
      fill: "#1c6f97"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.47,16.58l-.69-3a2.83,2.83,0,0,0-2.84-2.39.34.34,0,0,0-.31.21l-1,3.15-.37-1.88h.07a.23.23,0,0,0,.23-.23v-.65a.23.23,0,0,0-.23-.24h-.85a.23.23,0,0,0-.23.24v.65a.23.23,0,0,0,.23.23h.07l-.37,1.88L13,11.34a.3.3,0,0,0-.3-.22,2.86,2.86,0,0,0-2.85,2.4l-.69,3a1.1,1.1,0,0,0,1.06,1.34H19.4A1.09,1.09,0,0,0,20.47,16.58Z",
    style: {
      fill: "#1c6f97"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.82,
    cy: 7.52,
    r: 3.36,
    style: {
      fill: "#1c6f97"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPartnerComBlue);
export default __webpack_public_path__ + "static/media/icon_partner_com_blue.cd32fd7259c29fe6c537beadfaf09da4.svg";
export { ForwardRef as ReactComponent };